import React, { useRef, useState, useEffect } from 'react';
import * as THREE from 'three';
import * as d3 from 'd3';
export default function AssayLoader({name,url,visible}) {
    const floader = new THREE.FileLoader();
    const [assayData, setAssays] = useState([]);
    const meshRef = useRef();

    const constants_ = [259333,8156513,1120];

    function loadAssay() {
        floader.load(
            url,
            function (data) {
                const rows = d3.csvParse(data);
                let assays = [];
                rows.forEach(function (record) {
                    var displayData = {};                    

                    if (Number(record.LENGTH) && Number(record.LENGTH) > 0) {
                        displayData = {
                            holeid: record.BHID,
                            channelID: record.SampleID,
                            length: Number(record.LENGTH).toFixed(2),
                            grade: Number(record.AU)
                        };

                        placechannel(displayData, record.X, record.Y, record.Z,record.FROM,record.TO);
                    }
                });
                setAssays(assays);

                function placechannel(dd, x, y, z, from=0,to=0) {
                    
                    var startX = x - constants_[0];
                    var startY = z - constants_[2];
                    var startZ = constants_[1] -y;

                    var spherePosition = new THREE.Vector3(
                        startX ,
                        startY,
                        startZ 
                    );

                    assays.push({ pos: spherePosition, grade: dd.grade , holeid:dd.holeid,channelid:dd.channelID,from,to });
                }
            },
            function (xhr) {
                // Progress tracking for model loading
            },
            function (err) {
                console.error('An error happened');
            }
        );
       // Data processing complete
    }

    useEffect(() => {
        loadAssay();
    }, []);

    // Memory cleanup on unmount
    useEffect(() => {
        return () => {
            if (meshRef.current) {
                // Dispose of geometry and material
                if (meshRef.current.geometry) {
                    meshRef.current.geometry.dispose();
                }
                if (meshRef.current.material) {
                    meshRef.current.material.dispose();
                }
            }
        };
    }, []);

    return (
        <SphereInstancedMesh assayData={assayData} visible={visible} />
    );
}

const SphereInstancedMesh = ({ key, assayData , visible }) => {
    const meshRef = useRef();
    const count = assayData.length;
    const [colors, setColors] = useState(new Float32Array(count));
    const [instancesData, setInstancesData] = useState([]);

    useEffect(() => {
        let idata = [];
        if (meshRef.current) {
            const dummy = new THREE.Object3D();
            const color = new THREE.Color();
            const colorsArray = new Float32Array(assayData.length * 3);

            // Processing assay data
            assayData.forEach((assay, i) => {
                dummy.position.copy(assay.pos);
                dummy.updateMatrix();
                meshRef.current.setMatrixAt(i, dummy.matrix);
               // Process individual assay data
                idata.push({grade:assay.grade+' g/t'})

                const grade = assay.grade;
                if (grade > 5) {
                    color.set(0xA020F0); // purple
                } else if (grade > 3) {
                    color.set(0xfc6a03); // orange
                } else if (grade > 1) {
                    color.set(0x00ff00); // green
                } else {
                    color.set(0xfffff0); // white
                }
                
                colorsArray[i * 3] = color.r;
                colorsArray[i * 3 + 1] = color.g;
                colorsArray[i * 3 + 2] = color.b;
            });
            setColors(colorsArray)

            setInstancesData(idata)
            meshRef.current.instanceMatrix.needsUpdate = true;
            //meshRef.current.instanceColor.needsUpdate = true;
        }
    }, [assayData]);

    return (
        <instancedMesh visible={visible} ref={meshRef} args={[null, null, count]}  userData={{instancesData:instancesData}} >
            <sphereGeometry args={[0.5, 4, 4]}>
                <instancedBufferAttribute attach="attributes-color" args={[colors, 3]} />
            </sphereGeometry>
            <meshLambertMaterial vertexColors toneMapped={false} />
        </instancedMesh>
    );
};
